import { View, ViewStyle } from "react-native"

import Animated, { SharedValue, useAnimatedStyle } from "react-native-reanimated"

interface WaveformAnimationProps {
  volume: SharedValue<number>
  height?: number
  amplitude?: number
  barCount?: number
  barWidth?: number
  barSpacing?: number
  color?: string
}

// Utility type to make all properties required
type Required<T> = {
  [P in keyof T]-?: T[P]
}

interface WaveformBarProps extends Required<WaveformAnimationProps> {
  index: number
}

function WaveformBar({
  barSpacing,
  barWidth,
  volume,
  height,
  amplitude,
  index,
  barCount,
  color,
}: WaveformBarProps) {
  const $barStyleConstraints: ViewStyle = {
    minHeight: height / 5,
    maxHeight: height,
    width: barWidth,
    marginHorizontal: barSpacing,
    backgroundColor: color,
  }

  const $barStyleHeight = useAnimatedStyle(() => {
    const barHeight = amplitude * volume.value * calculateBarMultiplier(index, barCount)
    return {
      height: barHeight,
    }
  })

  return (
    <Animated.View key={`${index}`} style={[$barStyle, $barStyleConstraints, $barStyleHeight]} />
  )
}

export const WaveformAnimation = ({
  volume,
  height = 50,
  amplitude = 10,
  barCount = 9,
  barWidth = 10,
  barSpacing = 2,
  color = "#FFFFFF",
}: WaveformAnimationProps) => {
  return (
    <View style={{ ...$row, height }}>
      {[...Array(barCount)].map((_, index) => (
        <WaveformBar
          key={index}
          volume={volume}
          height={height}
          amplitude={amplitude}
          index={index}
          barCount={barCount}
          barWidth={barWidth}
          barSpacing={barSpacing}
          color={color}
        />
      ))}
    </View>
  )
}

const $barStyle: ViewStyle = {
  borderRadius: 2,
}

const $row: ViewStyle = {
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  paddingHorizontal: 10,
}

const calculateBarMultiplier = (index: number, barCount: number) => {
  "worklet"

  // Calculate the heights so that the middle one is the largest.
  const middleIndex = Math.floor(barCount / 2)
  const difference = Math.abs(middleIndex - index)
  const multiplier = 1 - difference / middleIndex
  return multiplier
}
